import { IChannelNotificationResponse } from "@wingspanhq/notifications/dist/lib/interfaces";
import { selectorActiveNotifications } from "./selectorActiveNotifications";

import { NotificationHandleType } from "../components/Notifications";
import { SignatureCollaboratorContext } from "../components/Notifications/templates/SignatureCollaborator";

export const selectorSignatureCollaboratorNotifications = (
  responses: IChannelNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return response.handle === NotificationHandleType.SignatureCollaborator;
  }) as Array<
    Omit<IChannelNotificationResponse, "context"> & {
      context: SignatureCollaboratorContext;
    }
  >;
};
